import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faTag,
  faFlask,
  faRotateLeft,
  faCodeCompare,
  faCodeBranch,
} from '@fortawesome/free-solid-svg-icons';

const VersionHistoryMock = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
    <div className="bg-[#181825] rounded-lg border border-white/[0.06] p-4">
      {/* Header */}
      <div className="flex items-center gap-2 mb-4 text-sm font-medium text-gray-300">
        <FontAwesomeIcon icon={faCodeBranch} className="text-gray-400" />
        Version History
        <span className="text-gray-500 font-normal">(4)</span>
      </div>

      {/* Timeline */}
      <div className="relative">
        {/* v4 - current */}
        <div className="relative pl-8 pb-5 group">
          <div className="absolute left-3 top-0 bottom-0 w-px bg-gray-700" />
          <div className="absolute left-1 top-1 w-5 h-5 rounded-full bg-blue-500 border-2 border-blue-500 flex items-center justify-center">
            <FontAwesomeIcon icon={faCheck} className="text-[8px] text-white" />
          </div>
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="font-mono text-[12px] font-medium text-gray-100">v4</span>
                <span className="px-1.5 py-0.5 text-[8px] font-medium bg-blue-900/40 text-blue-300 rounded">current</span>
              </div>
              <p className="mt-0.5 text-[11px] text-gray-400 truncate">Tightened slow length range after WFA</p>
              <div className="mt-1 flex items-center gap-3 text-[10px] text-gray-500">
                <span>2h ago</span>
                <span className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faFlask} className="text-[8px]" />
                  3 experiments
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* v3 */}
        <div className="relative pl-8 pb-5 group">
          <div className="absolute left-3 top-0 bottom-0 w-px bg-gray-700" />
          <div className="absolute left-1 top-1 w-5 h-5 rounded-full bg-gray-800 border-2 border-gray-600" />
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="font-mono text-[12px] font-medium text-gray-100">v3</span>
                <span className="flex items-center gap-1 px-1.5 py-0.5 text-[8px] font-medium bg-purple-900/40 text-purple-300 rounded">
                  <FontAwesomeIcon icon={faTag} className="text-[7px]" />
                  stable-candidate
                </span>
              </div>
              <p className="mt-0.5 text-[11px] text-gray-400 truncate">Added RSI filter to entry logic</p>
              <div className="mt-1 flex items-center gap-3 text-[10px] text-gray-500">
                <span>3d ago</span>
                <span className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faFlask} className="text-[8px]" />
                  5 experiments
                </span>
              </div>
            </div>
            <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="p-1.5 text-gray-400 hover:text-blue-400 hover:bg-gray-700 rounded">
                <FontAwesomeIcon icon={faRotateLeft} className="text-[10px]" />
              </span>
              <span className="p-1.5 text-gray-400 hover:text-amber-400 hover:bg-gray-700 rounded">
                <FontAwesomeIcon icon={faCodeCompare} className="text-[10px]" />
              </span>
            </div>
          </div>
        </div>

        {/* v2 */}
        <div className="relative pl-8 pb-5 group">
          <div className="absolute left-3 top-0 bottom-0 w-px bg-gray-700" />
          <div className="absolute left-1 top-1 w-5 h-5 rounded-full bg-gray-800 border-2 border-gray-600" />
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="font-mono text-[12px] font-medium text-gray-100">v2</span>
              </div>
              <p className="mt-0.5 text-[11px] text-gray-400 truncate">Switched to EMA cross from SMA</p>
              <div className="mt-1 flex items-center gap-3 text-[10px] text-gray-500">
                <span>12d ago</span>
                <span className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faFlask} className="text-[8px]" />
                  2 experiments
                </span>
              </div>
            </div>
            <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="p-1.5 text-gray-400 hover:text-blue-400 hover:bg-gray-700 rounded">
                <FontAwesomeIcon icon={faRotateLeft} className="text-[10px]" />
              </span>
              <span className="p-1.5 text-gray-400 hover:text-amber-400 hover:bg-gray-700 rounded">
                <FontAwesomeIcon icon={faCodeCompare} className="text-[10px]" />
              </span>
            </div>
          </div>
        </div>

        {/* v1 */}
        <div className="relative pl-8 pb-1 group">
          <div className="absolute left-1 top-1 w-5 h-5 rounded-full bg-gray-800 border-2 border-gray-600" />
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="font-mono text-[12px] font-medium text-gray-300">v1</span>
              </div>
              <p className="mt-0.5 text-[11px] text-gray-500 truncate">Initial strategy version</p>
              <div className="mt-1 flex items-center gap-3 text-[10px] text-gray-500">
                <span>28d ago</span>
              </div>
            </div>
            <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="p-1.5 text-gray-400 hover:text-blue-400 hover:bg-gray-700 rounded">
                <FontAwesomeIcon icon={faRotateLeft} className="text-[10px]" />
              </span>
              <span className="p-1.5 text-gray-400 hover:text-amber-400 hover:bg-gray-700 rounded">
                <FontAwesomeIcon icon={faCodeCompare} className="text-[10px]" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default VersionHistoryMock;
